module.exports = __webpack_public_path__ + "img/BOV protest opening statement.210dcdff.png";